/**
 * Platform/browser detection utilities (TICKET-281c).
 * @module utils/platform
 */

/**
 * Detect Apple iOS / iPadOS, including iPadOS 13+ which reports as MacIntel
 * with multi-touch capability.
 *
 * @returns `true` when running on an iOS / iPadOS device, otherwise `false`.
 */
export function isIos(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  return navigator.platform === 'MacIntel' && (navigator.maxTouchPoints ?? 0) > 1;
}

/**
 * Pick the first MIME type from a candidate list that the runtime
 * `MediaRecorder` claims to support.
 *
 * @param candidates - Ordered list of MIME strings to test.
 * @returns The first supported MIME, or `null` if `MediaRecorder` is unavailable
 *          or none of the candidates are supported.
 */
export function pickSupportedMimeType(candidates: readonly string[]): string | null {
  if (typeof MediaRecorder === 'undefined') return null;
  for (const mime of candidates) {
    try {
      if (MediaRecorder.isTypeSupported(mime)) return mime;
    } catch {
      // Some browsers throw on invalid mime; treat as unsupported and continue.
    }
  }
  return null;
}
